import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-4997af3e"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "relative py-16 bg-gray-50 section" };
var _hoisted_2 = { class: "container" };
var _hoisted_3 = { class: "flex flex-col items-center" };
var _hoisted_4 = ["textContent"];
var _hoisted_5 = ["innerHTML"];
var _hoisted_6 = { class: "m-auto mt-8 max-w-4xl" };
var _hoisted_7 = ["src"];
var _hoisted_8 = { class: "flex-grow mt-5 sm:mt-0" };
var _hoisted_9 = ["textContent"];
var _hoisted_10 = ["innerHTML"];
import { useLandingBlock } from '@student/components/Landing/Course/Blocks/useLandingBlock';
export default /*#__PURE__*/ _defineComponent({
    __name: 'WhatWillYouLearn',
    props: {
        landingBlock: {}
    },
    setup: function (__props, _a) {
        var __emit = _a.emit;
        var props = __props;
        var emit = __emit;
        var _b = useLandingBlock(function () { return props.landingBlock; }), landingBlock = _b.landingBlock, cards = _b.cards, isLinkIcon = _b.isLinkIcon, parseTextWithUrl = _b.parseTextWithUrl;
        return function (_ctx, _cache) {
            var _component_e_icon = _resolveComponent("e-icon");
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        (_unref(landingBlock).title)
                            ? (_openBlock(), _createElementBlock("h2", {
                                key: 0,
                                class: "max-w-lg font-medium text-center text-3xl md:text-5xl",
                                textContent: _toDisplayString(_unref(landingBlock).title)
                            }, null, 8, _hoisted_4))
                            : _createCommentVNode("", true),
                        (_unref(landingBlock).subtitle)
                            ? (_openBlock(), _createElementBlock("p", {
                                key: 1,
                                class: "mt-4 max-w-lg text-lg font-medium text-center",
                                innerHTML: _unref(parseTextWithUrl)(_unref(landingBlock).subtitle)
                            }, null, 8, _hoisted_5))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cards), function (card) {
                            return (_openBlock(), _createElementBlock("div", {
                                key: card.id,
                                class: "flex relative flex-col col-span-4 items-center py-7 px-6 rounded-lg transition-colors card group sm:flex-row"
                            }, [
                                _createElementVNode("div", {
                                    class: _normalizeClass([[
                                            {
                                                'bg-primary': _unref(isLinkIcon)(card.image)
                                            }
                                        ], "card__icon sm:mr-7 shrink-0 relative rounded-full flex justify-center items-center"])
                                }, [
                                    (card.image && !_unref(isLinkIcon)(card.image))
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            src: card.image,
                                            class: "w-14 h-14"
                                        }, null, 8, _hoisted_7))
                                        : (card.image && _unref(isLinkIcon)(card.image))
                                            ? (_openBlock(), _createBlock(_component_e_icon, {
                                                key: 1,
                                                icon: card.image,
                                                class: "w-10 h-10 text-white",
                                                public: ""
                                            }, null, 8, ["icon"]))
                                            : (_openBlock(), _createBlock(_component_e_icon, {
                                                key: 2,
                                                class: "w-10 h-10 text-white",
                                                icon: "image-stack"
                                            }))
                                ], 2),
                                _createElementVNode("div", _hoisted_8, [
                                    (card.title)
                                        ? (_openBlock(), _createElementBlock("p", {
                                            key: 0,
                                            class: "mt-1 text-2xl text-center font-medium sm:text-left",
                                            textContent: _toDisplayString(card.title)
                                        }, null, 8, _hoisted_9))
                                        : _createCommentVNode("", true),
                                    (card.description)
                                        ? (_openBlock(), _createElementBlock("p", {
                                            key: 1,
                                            class: "mt-3 text-xl text-center text-opacity-50 card__description text-dark sm:text-left",
                                            innerHTML: _unref(parseTextWithUrl)(card.description)
                                        }, null, 8, _hoisted_10))
                                        : _createCommentVNode("", true)
                                ])
                            ]));
                        }), 128))
                    ])
                ])
            ]));
        };
    }
});
